






























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Attribute } from '@/interfaces/Attribute';
import { Category } from '@/interfaces/Category';
import axios from 'axios';
import env from '@/env';
import SaveButton from '@/components/App/SaveButton.vue';
import AttributeCategorizedListTabItem from '@/components/Attributes/AttributeCategorizedListTabItem.vue';
import { Environment } from '@/interfaces/Environment';

@Component({
  components: { AttributeCategorizedListTabItem, SaveButton }
})
export default class AttributeCategorizedList extends Vue {
  @Prop()
  attributes!: Attribute[];

  @Prop()
  categories!: Category[];

  @Prop()
  environments!: Environment[];

  @Prop()
  save?: () => Promise<any>;

  @Prop()
  selectedEnvironment?: number;

  attributesByCategory: Record<number | 'null', Attribute[]> = { null: [] };

  async addCategory(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    const { data: category } = await axios.post(`${env.backend_url}/attribute/category`, {
      name: 'Neue Kategorie',
      color: '#FFFFFF'
    });
    this.categories.push(category);
  }

  async changeCategoryOfAttribute(attribute: Attribute, category: Category) {
    const index = this.attributesByCategory[attribute.category_id as number].indexOf(attribute);
    this.attributesByCategory[attribute.category_id as number].splice(index, 1);

    if (!this.attributesByCategory[category.id]) this.attributesByCategory[category.id] = [];
    this.attributesByCategory[category.id] = [...this.attributesByCategory[category.id], attribute];
    attribute.category_id = category.id;
  }

  async deleteCategory(category: Category) {
    this.attributes.forEach((attribute) => {
      if (attribute.category_id === category.id) {
        attribute.category_id = null;
        this.changeCategoryOfAttribute(attribute, ({ id: 'null' } as unknown) as Category);
      }
    });

    await axios.delete(`${env.backend_url}/attribute/category/${category.id}`);

    const index = this.categories.indexOf(category);
    this.categories.splice(index, 1);
  }

  async created() {
    this.buildAttributesByCategory();
  }

  @Watch('attributes')
  watchAttributes() {
    this.buildAttributesByCategory();
  }

  buildAttributesByCategory() {
    this.attributesByCategory = this.attributes.reduce(
      (
        accumulator: Record<number | 'null', Attribute[]>,
        current: Attribute
      ): Record<number | 'null', Attribute[]> => {
        let categoryId: number | 'null' = current.category_id || 'null';
        if (current.blueprint?.category_id !== undefined) {
          categoryId = current.blueprint.category_id || 'null';
        }

        if (!accumulator[categoryId]) accumulator[categoryId] = [];
        accumulator[categoryId].push(current);
        return accumulator;
      },
      { null: [] }
    );
  }

  tab = 0;
}
